<div *ngIf='canShowCarousel' class='carousel-margin'>
  <app-carousel></app-carousel>
</div>
<div class='container'>
  <div class='row mt-1' *ngIf='!isHome && isLoggedIn'>
    <div class='col-12'>
      <ol *ngIf='(breadcrumbs$ | async)?.length' class='breadcrumb'>
        <ng-container *ngFor='let breadcrumb of breadcrumbs$ | async; let i = index'>
          <li *ngIf="breadcrumb.label !== ''" class='breadcrumb-item'>
            <a *ngIf='breadcrumb.isSelectableSegment' class='hyperlink'
               (click)='onSelectBreadcrumb(breadcrumb)'>
              {{ breadcrumb.label }}
            </a>
            <a *ngIf='!breadcrumb.isSelectableSegment' class='not-selectable'>{{ breadcrumb.label }}</a>
            <a *ngIf='breadcrumb.label === null' class='not-selectable'>
              {{ breadcrumbVariable | async }}
            </a>
          </li>
        </ng-container>
      </ol>
    </div>
  </div>

  <div class='row'>
    <div
      [class]="isLoggedIn ? 'col-12 col-md-9 col-lg-9' : 'col-12'">
      <router-outlet></router-outlet>
    </div>
    <div *ngIf='isLoggedIn' class='col-12 col-md-3 col-lg-3 pb-4 hide-widget'>
      <app-widgets></app-widgets>
    </div>
  </div>
</div>
